import "./Services.css";
import Button from "../Button/Button";
const Services = () => {

   const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  }
    
  return (
    <div id="service" className="divWrapper">
      <div className="arvrcontainer sContainer">
        <div className="serviceContent">
          
           <h2>Searching for the Best VR Development Services?</h2>
          <p>
            You’ve found them. With deep industry expertise and a passion for
            immersive tech, we offer the <strong>best VR development services</strong> designed
            to elevate your brand experience through custom-built solutions.
          </p>
          <div onClick={handleScrollToTop}><Button  arrowColor="purple" text="Let's Talk"/></div>
        </div>
      </div>
    </div>
  );
};

export default Services;
